module.exports = __webpack_public_path__ + "media/theme/icon__payment-b6eb0539.png";